import React from "react";
import { FilePreview } from "cxa-components";
import { FileUploader } from "../common/file-uploader";
import { withState } from "recompose";
import { getFileProps } from "cxa-utils";
import { FormField } from "cxa-form-field";
import { ACCEPT_FILES, MAX_FILE_SIZE } from "../constants";
import { renderRejectedFiles, resizeImage } from "./util";

const enhanceWithRejectedReceiptFiles = withState("rejectedFiles", "setRejectedFiles", []);

const renderReceiptUploader = enhanceWithRejectedReceiptFiles(
  ({
    name,
    value,
    onChange,
    onBlur,
    onDrop,
    rejectedFiles,
    setRejectedFiles,
    meta,
    error,
    allowDelete,
    ...rest
  }) => {
    return (
      <div>
        <FileUploader
          accept={ACCEPT_FILES}
          maxSize={MAX_FILE_SIZE}
          onDrop={(files, rejectedFiles) => {
            let fileList = value && value.length > 0 ? [...value] : [];
            files.map(file => {
              return resizeImage(file, fileList, onChange);
            });
            setRejectedFiles(rejectedFiles);
          }}
          {...rest}
        />
        {!error && renderRejectedFiles(rejectedFiles)}
        {Array.isArray(value) &&
          value.length > 0 &&
          value.map(file => {
            const onDelete = () => onChange(value.filter(item => item != file));
            const fileProps = getFileProps(file);
            return (
              <FilePreview
                key={fileProps.name}
                {...fileProps}
                onDelete={onDelete}
                disabled={!allowDelete && !fileProps.isLocalFile}
              />
            );
          })}
      </div>
    );
  }
);

const ReceiptField = props => (
  <FormField multiple={true} component={renderReceiptUploader} {...props} />
);

export default ReceiptField;



// WEBPACK FOOTER //
// ./components/claim/ReceiptField.js